import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { APP_CONFIG } from '@application/config';
import { EInactivationChoiceOption } from '@settings/data-access';
import { Observable } from 'rxjs';
import {
  TInactivationAttempt,
  TInactivationChoiceRequest,
} from '../entities/inactivation-attempt.model';

/**
 * HTTP of the inactivation router (personservice `PersonController`, feature
 * 003). Both routes need `ClienteInativar`.
 *
 * Refusals: 403 (no permission), 404 (attempt not of this person), 503 with
 * `Code: "dependency-unavailable"` (the subscriptionservice did not answer —
 * never offer "inativar mesmo assim").
 */
@Injectable({ providedIn: 'root' })
export class InactivationAttemptService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(APP_CONFIG).apiUrl.personService;

  /** Asks whether the person file can be inactivated now. No body. */
  public create(personId: string): Observable<TInactivationAttempt> {
    return this.http.post<TInactivationAttempt>(
      `${this.baseUrl}/Person/${personId}/InactivationAttempts`,
      null,
      { withCredentials: true }
    );
  }

  /** Records the router choice (204). Repeating a choice is idempotent. */
  public recordChoice(
    personId: string,
    attemptId: string,
    option: EInactivationChoiceOption
  ): Observable<void> {
    const body: TInactivationChoiceRequest = { Option: option };
    return this.http.post<void>(
      `${this.baseUrl}/Person/${personId}/InactivationAttempts/${attemptId}/Choice`,
      body,
      { withCredentials: true }
    );
  }
}
